import { useEffect, useState } from 'react';
import { Breakpoint } from '@types';

enum MediaQueries {
    small = 576,
    medium = 768,
    large = 992,
    extraLarge = 1200,
    extraExtraLarge = 1400,
}

const calculateActiveBreakpoint = () => {
    return window.matchMedia(`(min-width: ${MediaQueries.extraExtraLarge}px)`).matches
        ? Breakpoint.xxl
        : window.matchMedia(`(min-width: ${MediaQueries.extraLarge}px)`).matches
          ? Breakpoint.xl
          : window.matchMedia(`(min-width: ${MediaQueries.large}px)`).matches
            ? Breakpoint.lg
            : window.matchMedia(`(min-width: ${MediaQueries.medium}px)`).matches
              ? Breakpoint.md
              : window.matchMedia(`(min-width: ${MediaQueries.small}px)`).matches
                ? Breakpoint.sm
                : Breakpoint.xs;
};

export const useMediaQuery: () => Breakpoint = () => {
    const [activeBreakpoint, setActiveBreakpoint] = useState<Breakpoint | null>(null);

    useEffect(() => {
        const mediaXXL = window.matchMedia(`(min-width: ${MediaQueries.extraExtraLarge}px)`);
        const mediaXL = window.matchMedia(`(min-width: ${MediaQueries.extraLarge}px)`);
        const mediaLG = window.matchMedia(`(min-width: ${MediaQueries.large}px)`);
        const mediaMD = window.matchMedia(`(min-width: ${MediaQueries.medium}px)`);
        const mediaSM = window.matchMedia(`(min-width: ${MediaQueries.small}px)`);

        const currentActiveBreakpoint = calculateActiveBreakpoint();

        if (currentActiveBreakpoint !== activeBreakpoint) {
            setActiveBreakpoint(currentActiveBreakpoint);
        }

        const listener = () => {
            setActiveBreakpoint(calculateActiveBreakpoint());
        };

        mediaXXL.addListener(listener);
        mediaXL.addListener(listener);
        mediaLG.addListener(listener);
        mediaMD.addListener(listener);
        mediaSM.addListener(listener);

        return () => {
            mediaXXL.removeListener(listener);
            mediaXL.removeListener(listener);
            mediaLG.removeListener(listener);
            mediaMD.removeListener(listener);
            mediaSM.removeListener(listener);
        };
    }, [activeBreakpoint]);

    return activeBreakpoint || Breakpoint.xs;
};
